module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4MDAiIGhlaWdodD0iNTAwIj48cGF0aCBmaWxsPSIjNEFBREQ2IiBkPSJNMCAwaDgwMHY1MDBIMHoiLz48Y2lyY2xlIGZpbGw9IiNGRkRFMDAiIGN4PSIzNTAiIGN5PSIyNTAiIHI9IjE1MCIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/plw.svg
// module id = ObPo
// module chunks = 0